import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { CartService } from './modules/products/services/cart.service';
import { AuthInterceptor, LocalDataInterceptor, LoadingInterceptor, NotificationInterceptor } from './shared/interceptors';
import { PermissionService } from './shared/services/permission.service';

function initPermissions(permissionService: PermissionService) {
  return () => {
    // Only attempt if a user is already logged in.
    const storedUser = localStorage.getItem('currentUser');
    if (!storedUser) return;

    // Hydrate immediately (sync) then refresh in background (async).
    permissionService.hydrateFromLocalStorage('WEB');
    permissionService.loadFeatureHierarchyPermissions('WEB', true).subscribe();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        AuthInterceptor,
        LocalDataInterceptor,
        LoadingInterceptor,
        NotificationInterceptor,
      ])
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      enableHtml: false,
      toastClass: 'ngx-toastr',
      titleClass: 'toast-title',
      messageClass: 'toast-message',
      tapToDismiss: true,
      maxOpened: 1,
      autoDismiss: true,
      newestOnTop: true,
      countDuplicates: true,
      resetTimeoutOnDuplicate: true,
      includeTitleDuplicates: true,
      extendedTimeOut: 1000
    }),
    CartService,
    {
      provide: APP_INITIALIZER,
      useFactory: initPermissions,
      deps: [PermissionService],
      multi: true
    }
  ]
};
